(function () {
  angular.module("akitabox.ui.dialogs.displayText", [
    "akitabox.core.constants",
    "ngMaterial",
  ]);
})();
